import React from "react";
import * as THREE from 'three';

import LayerMappingsEnum from '../enums/LayerMappingsEnum';

const Stage2d = () => {

    const Layers2d = new THREE.Layers();
    Layers2d.set(LayerMappingsEnum.Stage);

    return (
        <>
            {/* NOTE: It seems that ambient light does not do anything, so it is commented for now  */}
            {/* { <ambientLight layers={Layers2d} intensity={1.0} color="red" />         } */}
        </>
    );
};

export default Stage2d;